import React, { useEffect, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import { dateFormat } from 'helpers/date'
import useTableFixedHeader from 'hooks/useTableFixedHeader'
import ContentHeader from 'components/UI/ContentHeader/ContentHeader'
import THead from 'components/ContentBox/Global/ReportTable/THead'
import Loader from 'components/ContentBox/Global/Loader/Loader'
import st from 'components/ContentBox/Global/ReportTable/Table.module.scss'
import { NavLink, useHistory } from 'react-router-dom'
import { ExcelRowsParams, setCellParams } from 'components/utils/ExcelExport'
import { observer } from 'mobx-react'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import useLocalization from 'hooks/useLocalization'
import SearchBooks from 'components/Modules/Ebook/Books/components/SearchBooks/SearchBooks'
import FilterTextValues from 'components/UI/AsideFilter/FilterTextValues'
import AsideFilter from 'components/UI/AsideFilter/AsideFilter'
import ExportExcelButton from '../ExportExcelButton/ExportExcelButton'
import { timeConverter } from 'components/ContentBox/Online-schedule/components/functions'

const GroupStages = () => {
  const [catalog, setCatalog] = useState({})
  const [filter, updateFilter] = useLocalStorageFilter()
  const {
    isOpenFilter,
    closeFilter,
    setTextValues,
    changeTextValue,
    filterTextValues,
  } = AsideFilterStore
  const history = useHistory()

  const {
    refWrapper,
    refSticky,
    refThead,
    data,
    setData,
    isLoading,
    setIsLoading,
  } = useTableFixedHeader()
  const dateAfter = new Date()
  dateAfter.setMonth(dateAfter.getMonth() - 1)
  const firstDayOfLastMoth = new Date(new Date(dateAfter).setDate(1))
  const lastDayOfLastMoth = new Date(new Date().setDate(0))
  const { translate } = useLocalization({
    section: 'ebooks',
    subsection: 'ebooks_books',
    dict: {
      edit: 'Edit',
      copy: 'Copy',
      delete: 'Delete',
      save: 'Save',
      filter: 'Filter',
      company: 'Company',
      reset_all: 'Reset all',
      apply: 'Apply',
      search: 'Search',
      start_date: 'Start date',
      end_date: 'End date',
    },
  })

  const filterCfg = [
    {
      type: 'select-multi',
      label: 'Локация',
      nameState: 'location',
      placeholder: 'Локация',
      values:
        catalog.locations?.sort((a, b) => (a.name > b.name ? 1 : -1)) || [],
      option_value_key: 'id',
      option_label_key: 'name',
    },
    {
      type: 'date_day_picker',
      nameState: ['date_from', 'date_until'],
      defaultDate: {
        after: firstDayOfLastMoth,
        before: lastDayOfLastMoth,
      },
      label: 'Период',
      isRequired: true,
    },
  ]

  const cfg = {
    cols: [
      {
        name: 'Локация',
      },
      {
        name: 'Группа',
      },
      {
        name: 'Формирование',
      },
      {
        name: 'Период в днях',
      },
      {
        name: 'В расписании',
      },
      {
        name: 'Период в днях',
      },
      {
        name: 'В работе',
      },
      {
        name: 'Период в днях',
      },
    ],
  }

  const minutesToDays = (minutes) =>
    minutes === null ? '-' : Math.ceil(minutes / (60 * 24))
  const dateConverter = (date) => dateFormat(new Date(date), 'YYYY-mm-dd')
  const calculateTotalDays = (data, key) =>
    data.reduce((acc, el) => (el[key] !== '-' ? acc + el[key] : acc), 0)
  const calculateTotalGroups = (key) =>
    data && data.filter((el) => el[key] !== null).length

  const totalForming = calculateTotalGroups('status_forming_at')
  const totalStatusWasChangedToInSchedule = calculateTotalGroups(
    'status_was_changed_to_in_schedule_at',
  )
  const totalFromFormingToWorking = calculateTotalGroups(
    'status_was_changed_to_working_at',
  )

  useEffect(() => {
    const params = { ...filter }

    setIsLoading(true)

    if (params.location && params.location.length > 0)
      params.location = `[${params.location.map((item) => item)}]`

    superAxiosRequest({
      method: 'get',
      link: 'progress_report/group_stages',
      params: params,
    })
      .then(({ data }) => {
        setCatalog(data)

        const transformedData = data.map((obj) => ({
          ...obj,
          from_forming_to_working_total_minutes: minutesToDays(
            obj.from_forming_to_working_total_minutes,
          ),
          in_forming_total_minutes: minutesToDays(obj.in_forming_total_minutes),
          in_schedule_total_minutes: minutesToDays(
            obj.in_schedule_total_minutes,
          ),
        }))
        setData(transformedData)
        setIsLoading(false)
      })
      .catch(() => {
        setIsLoading(false)
      })
  }, [filter])

  useEffect(() => {
    return AsideFilterStore.unmountFilter
  }, [])

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname !== '/reports/group_stages') {
        updateFilter({})
      }
    })
    return () => {
      unlisten()
    }
  }, [history, updateFilter])

  const downloadExcel = () => {
    import('xlsx-js-style').then((XLSX) => {
      const headRows = [
        [
          {
            v: 'Локация',
          },
          {
            v: 'Группа',
          },
          {
            v: 'Формирование',
          },
          {
            v: 'Период в днях',
          },
          {
            v: 'В расписании',
          },
          {
            v: 'Период в днях',
          },
          {
            v: 'В работе',
          },
          {
            v: 'Период в днях',
          },
        ],
      ]

      headRows[0] = setCellParams(headRows[0], ExcelRowsParams.headerRowParam)

      let wscols = [
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
      ]

      let tableData = []

      data.forEach((group) => {
        tableData.push([
          {
            v: `${group.location_name}`,
            ...ExcelRowsParams.tableRowParam.firstCell,
          },
          {
            v: `${group.group_number} - ${group.group_name}`,
            ...ExcelRowsParams.tableRowParam.cell,
          },
          {
            v: `${dateConverter(group.status_forming_at)}`,
            ...ExcelRowsParams.tableRowParam.cell,
          },
          {
            v: `${group.in_forming_total_minutes}`,
            ...ExcelRowsParams.tableRowParam.cell,
          },
          {
            v: `${group.status_was_changed_to_in_schedule_at ? dateConverter(group.status_was_changed_to_in_schedule_at) : '-'}`,
            ...ExcelRowsParams.tableRowParam.cell,
          },
          {
            v: `${group.in_schedule_total_minutes}`,
            ...ExcelRowsParams.tableRowParam.cell,
          },
          {
            v: `${dateConverter(group.status_was_changed_to_working_at)}`,
            ...ExcelRowsParams.tableRowParam.cell,
          },
          {
            v: `${group.from_forming_to_working_total_minutes}`,
            ...ExcelRowsParams.tableRowParam.cell,
          },
        ])
      })

      tableData.unshift([
        {
          v: `Итого`,
          ...ExcelRowsParams.footerRowParams.firstCell,
        },
        {
          v: `${data.length}`,
          ...ExcelRowsParams.footerRowParams.cell,
        },
        {
          v: `${totalForming}`,
          ...ExcelRowsParams.footerRowParams.cell,
        },
        {
          v: `${Math.round(calculateTotalDays(data, 'in_forming_total_minutes') / totalForming)}`,
          ...ExcelRowsParams.footerRowParams.cell,
        },
        {
          v: `${totalStatusWasChangedToInSchedule}`,
          ...ExcelRowsParams.footerRowParams.cell,
        },
        {
          v: `${Math.round(calculateTotalDays(data, 'in_schedule_total_minutes') / totalStatusWasChangedToInSchedule)}`,
          ...ExcelRowsParams.footerRowParams.cell,
        },
        {
          v: `${totalFromFormingToWorking}`,
          ...ExcelRowsParams.footerRowParams.cell,
        },
        {
          v: `${Math.round(calculateTotalDays(data, 'from_forming_to_working_total_minutes') / totalFromFormingToWorking)}`,
          ...ExcelRowsParams.footerRowParams.cell,
        },
      ])

      let wb = XLSX.utils.book_new()
      const ws = XLSX.utils.aoa_to_sheet([...headRows, ...tableData])
      ws['!cols'] = wscols

      XLSX.utils.book_append_sheet(wb, ws, 'List 1')
      XLSX.writeFile(wb, 'Запуск групп.xlsx')
    })
  }
  const isFilterEmpty = !filterTextValues.length

  return (
    <>
      <ContentHeader title='Запуск групп' />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          margin: '10px',
        }}
      >
        <SearchBooks
          onSearch={(text) => {
            updateFilter({ ...filter, search: text })
            changeTextValue('search', {
              key: 'search',
              label: 'Search',
              value: text,
            })
          }}
          onClear={() => {
            const { search, ...obj } = filter
            updateFilter(obj)
            setTextValues(
              filterTextValues.filter((field) => field.key !== 'search'),
            )
          }}
          translate={translate}
          placeholder={`Search...`}
          value={filter?.search || ''}
          isFilterEmpty={isFilterEmpty}
        />
        {!!filterTextValues.length && (
          <FilterTextValues
            onDelete={(key) => {
              const { [key]: _, ...obj } = filter
              updateFilter(obj)
            }}
          />
        )}
        {isOpenFilter && (
          <AsideFilter
            translate={translate}
            getFilterParams={updateFilter}
            config={filterCfg}
            filterValue={filter}
            onDropFilter={() => {
              updateFilter({})
              closeFilter()
            }}
          />
        )}
      </div>
      {isLoading ? (
        <Loader />
      ) : data && data.length > 0 ? (
        <>
          <div style={{ padding: '10px' }}>
            <ExportExcelButton data={[]} downloadExcel={downloadExcel} />
          </div>

          <div className={st.tableWrapper} ref={refWrapper}>
            <div ref={refSticky} className={st.sticky}>
              <table className={st.table}>
                <THead cols={cfg.cols} />
              </table>
            </div>
            <table className={st.table}>
              <THead cols={cfg.cols} ref={refThead} />
              <tbody className={`${st.tbody} ${st.tbodyStriped}`}>
                <>
                  <tr>
                    <td className={st.tdTotal}>Итого</td>
                    <td className={`${st.tdTotal} ${st.textAlignCenter}`}>
                      {data.length}
                    </td>
                    <td className={`${st.tdTotal} ${st.textAlignCenter}`}>
                      {totalForming}
                    </td>
                    <td className={`${st.tdTotal} ${st.textAlignCenter}`}>
                      {`${Math.round(calculateTotalDays(data, 'in_forming_total_minutes') / totalForming)}`}
                    </td>
                    <td className={`${st.tdTotal} ${st.textAlignCenter}`}>
                      {totalStatusWasChangedToInSchedule}
                    </td>
                    <td className={`${st.tdTotal} ${st.textAlignCenter}`}>
                      {`${Math.round(calculateTotalDays(data, 'in_schedule_total_minutes') / totalStatusWasChangedToInSchedule)}`}
                    </td>
                    <td className={`${st.tdTotal} ${st.textAlignCenter}`}>
                      {totalFromFormingToWorking}
                    </td>
                    <td className={`${st.tdTotal} ${st.textAlignCenter}`}>
                      {`${Math.round(calculateTotalDays(data, 'from_forming_to_working_total_minutes') / totalFromFormingToWorking)}`}
                    </td>
                  </tr>
                  {data.map((el, index) => {
                    return (
                      <tr key={index}>
                        <td className={`${st.color} ${st.fw500}`}>
                          {el.location_name}
                        </td>
                        <td className={`${st.textAlignCenter} ${st.fz12}`}>
                          <NavLink
                            to={'/groups/group/' + el.group}
                            target='_blank'
                          >
                            {`${el.group_number} - ${el.group_name}`}
                          </NavLink>
                        </td>
                        <td className={`${st.textAlignCenter} ${st.fz12}`}>
                          {dateConverter(el.status_forming_at)}
                        </td>
                        <td className={`${st.textAlignCenter} ${st.fz12}`}>
                          {el.in_forming_total_minutes}
                        </td>
                        <td className={`${st.textAlignCenter} ${st.fz12}`}>
                          {el.status_was_changed_to_in_schedule_at
                            ? dateConverter(
                                el.status_was_changed_to_in_schedule_at,
                              )
                            : '-'}
                        </td>
                        <td className={`${st.textAlignCenter} ${st.fz12}`}>
                          {el.in_schedule_total_minutes}
                        </td>
                        <td className={`${st.textAlignCenter} ${st.fz12}`}>
                          {dateConverter(el.status_was_changed_to_working_at)}
                        </td>
                        <td className={`${st.textAlignCenter} ${st.fz12}`}>
                          {el.from_forming_to_working_total_minutes}
                        </td>
                      </tr>
                    )
                  })}
                </>
                <></>
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <h1 className={st.noData}>Нет данных для отображения!</h1>
      )}
    </>
  )
}

export default observer(GroupStages)
